
namespace GeniuzPOS.InventoryReport {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class IcReport08Dialog extends Serenity.EntityDialog<IcReport08Row, any> {
        protected getFormKey() { return IcReport08Form.formKey; }
        protected getIdProperty() { return IcReport08Row.idProperty; }
        protected getLocalTextPrefix() { return IcReport08Row.localTextPrefix; }
        protected getNameProperty() { return IcReport08Row.nameProperty; }
        protected getService() { return IcReport08Service.baseUrl; }
        protected getDeletePermission() { return IcReport08Row.deletePermission; }
        protected getInsertPermission() { return IcReport08Row.insertPermission; }
        protected getUpdatePermission() { return IcReport08Row.updatePermission; }

        protected form = new IcReport08Form(this.idPrefix);
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);

            return buttons;
        }

    }
}